import { BiInfoCircle, BiMap, BiBone, BiHappy } from 'react-icons/bi';
import { Wrench } from 'lucide-react';

const itemTypeIcons = {
  PSA: BiInfoCircle,    
  Place: BiMap,      
  LostAnimal: BiBone,     
  FoundAnimal: BiHappy,
  PetService: Wrench,
};

export default itemTypeIcons;
